export enum CustomerPointOfContact {
  customer = 'Customer Poc:',
  subCustomer = 'Sub Customer Poc:',
}
